module.exports = __webpack_public_path__ + "img/26.f1a8628.jpg";